import {
  EmptyStringError,
  InvalidStringError,
  InvalidUrlError,
  UndefinedOrNullError
} from "./chunk-5XZTHQBU.mjs";
import {
  errorMessages
} from "./chunk-CXY23WTR.mjs";

// src/utils/string-validators.ts
var StringValidator = class _StringValidator {
  /**
   * Validate if a string is defined .
   *
   * string str - The string to be validated.
   * @throws UndefinedOrNullError - Thrown when an argument is undefined or null.
   *
   */
  static validateNullOrUndefined(str, key) {
    if (str === null) {
      throw new UndefinedOrNullError(errorMessages.UNDEFINED_PROPERTY + key);
    }
    if (str === void 0) {
      throw new UndefinedOrNullError(errorMessages.UNDEFINED_PROPERTY + key);
    }
  }
  /**
   * Validate if a string is typed .
   *
   * string str - The string to be validated.
   * @throws InvalidStringError - Thrown when an argument not a string.
   *
   */
  static validateString(str, key) {
    if (typeof str !== "string") {
      throw new InvalidStringError(errorMessages.INVALID_STRING + key);
    }
  }
  /**
   * Validate if the string length is grater than 0.
   *
   * string str - The string to be validated.
   * @throws EmptyStringError - Thrown when the argument length equal to 0.
   *
   */
  static validateEmptyString(str, key) {
    if (str.length === 0) {
      throw new EmptyStringError(errorMessages.EMPTY_STRING + key);
    }
  }
  /**
   * Validate if the url is valid.
   *
   * string str - The string to be validated.
   * @throws InvalidUrlError - Thrown when the URL is invalid.
   *
   */
  static validateUrl(url) {
    const validUrlRegex = /^(?:http|https):\/\/[^\s$.?#].[^\s]*$/;
    if (!validUrlRegex.test(url)) {
      throw new InvalidUrlError(errorMessages.INVALID_URL);
    }
  }
  /**
   * Validate the string value for an object
   *
   * string value - The value to be validated.
   */
  static validateStringValue(value, key) {
    _StringValidator.validateNullOrUndefined(value, key);
    _StringValidator.validateString(value, key);
    _StringValidator.validateEmptyString(value, key);
  }
};

export {
  StringValidator
};
